// SPDX-License-Identifier: Apache-2.0

import {
  jsonArrayMember,
  jsonMapMember,
  jsonMember,
  jsonObject
} from "typedjson";

export class ParamPart {
  @jsonMember(Number)
  backend!: number;

  @jsonMember(String)
  addr!: string;

  constructor(backend: number, addr: string) {
    this.backend = backend;
    this.addr = addr;
  }
}

@jsonObject()
export class Params {
  @jsonArrayMember(Number) id: Array<number>;
  @jsonMember(Number) challengeDuration: number;
  @jsonArrayMember(ParamPart, { dimensions: 2 })
  parts!: ParamPart[][];
  @jsonMember(String) app: string;
  @jsonMember(String) appType: string;
  @jsonMember(String) nonce: string;
  @jsonMember(Boolean) ledgerChannel: boolean;
  @jsonMember(Boolean) virtualChannel: boolean;

  constructor(
    pId: Array<number>,
    challengeDuration: number,
    parts: ParamPart[][],
    app: string,
    appType: string,
    nonce: string,
    ledgerChannel: boolean,
    virtualChannel: boolean,
  ) {
    this.id = pId;
    this.challengeDuration = challengeDuration;
    console.log("Params parts:", parts);
    this.parts = parts;
    this.app = app;
    this.appType = appType;
    this.nonce = nonce;
    this.ledgerChannel = ledgerChannel;
    this.virtualChannel = virtualChannel;
  }
}

@jsonObject()
export class SubAlloc {
  @jsonArrayMember(Number) asId: number[];
  @jsonArrayMember(Number) bals: number[];
  @jsonArrayMember(Number) indexMap: number[];

  constructor(asId: number[], bals: number[], indexMap: number[]) {
    this.asId = asId;
    this.bals = bals;
    this.indexMap = indexMap;
  }
}

@jsonObject()
export default class Allocation {
  @jsonArrayMember(String) assets: string[];
  @jsonArrayMember(Number) backends: number[];
  @jsonArrayMember(String, { dimensions: 2 }) balances: Array<Array<string>>;
  @jsonArrayMember(SubAlloc, {
    serializer: (subAlloc: SubAlloc) => {
      return {
        asId: subAlloc.asId,
        bals: subAlloc.bals,
        indexMap: subAlloc.indexMap,
      };
    },
  })
  locked: Array<SubAlloc>;

  constructor(
    assets: string[],
    backends: number[],
    balances: Array<Array<string>>,
    locked: Array<SubAlloc>,
  ) {
    this.assets = assets;
    this.backends = backends;
    this.balances = balances;
    this.locked = locked;
  }
}

@jsonObject()
export class Data {
  @jsonMember(Function) Clone!: () => Data;

  constructor(Clone: () => Data) {
    this.Clone = Clone;
  }
}

@jsonObject()
export class SState {
  @jsonArrayMember(Number) id: Array<number>;
  @jsonMember(Number) version: number;
  @jsonMember(String) app: string;
  @jsonMember(String) appType: string;
  @jsonMember(Allocation) allocation: Allocation;
  @jsonMember(String) data: string;
  @jsonMember(Boolean) isFinal: boolean;

  constructor(
    id: Array<number>,
    version: number,
    app: string,
    appType: string,
    allocation: Allocation,
    data: string,
    isFinal: boolean,
  ) {
    this.id = id;
    this.version = version;
    this.app = app;
    this.appType = appType;
    this.allocation = allocation;
    this.data = data;
    this.isFinal = isFinal;
  }
}
